import { AssignmentStore, AsyncHelper, DateHelper } from "@bryntum/gantt/gantt.module";
import {
  addClasses,
  addDeadlineDateToTasks,
  addNoResizeAndDrag,
  flatTasks,
  ganttColors,
  getMinMaxDate,
  getScrollToTaskContextMenu,
  getSplitTaskByHourContextMenu,
  getSplitTaskContextMenu,
  getUnDoSplitTaskContextMenu,
  getRollupContextMenu,
  getViewPresets,
  getWorkingTime,
  getYesNoColumnFilter,
  mergeColumns,
  prepareResources,
  preventAddAssignmentsForOutsourced,
  ridderTypes,
  setMinDurationToPreventBeMilestone,
  taskBarTooltip,
  setCursorAtEnd,
  updateTaskbarColorClasses,
  getHeaderContextMenu
} from "../../../utils/ganttUtils";
import GanttTask from "../../../utils/overrides/GanttTask";
import GanttDependency from "../../../utils/overrides/GanttDepencency";
import { translate } from "../../../utils/translate";
import { defaultViewPreset } from "../../../utils/constants";
import { OurCycleResolutionPopup, OurSchedulingIssueResolutionPopup } from "../../../utils/ConflictResolutionOveride";
import { dateTimeFormatter } from "../../../utils/format";
const getColumns = (configs, t) => {
  const defaultColumns = [
    {
      type: "name",
      field: "description",
      name: "description",
      text: "Name",
      editor: false,
      id: "name",
      width: 250,
      order: -1,
      region: "left",
    },
    {
      type: "startdate",
      field: "startDate",
      text: "Start",
      editor: {
        editable: false,
        autoExpand: true,
        autoClose: true,
      },
      width: 250,
      order: -1,
    },
    {
      type: "enddate",
      field: "endDate",
      text: "Finish",
      editor: {
        editable: false,
        autoExpand: true,
        autoClose: true,
      },
      width: 250,
      order: -1,
    },
    {
      type: "duration",
      text: translate("Duration"),
      order: -1,
    },
    {
      type: "resourceassignment",
      name: "resourceassignment",
      width: 100,
      order: -1,
    },
    {
      name: "PlannedHours",
      type: "effort",
      text: t("Planned hours"),
      order: -1,
      editor: false,
      field: "effort",
      filterable: false,
    },
    {
      field: "RidderType",
      text: t("Ridder type"),
      editor: {
        type: "combo",
        pickerWidth: 200,
        listItemTpl: (record) => `<span style="font-size: ${configs.fontSize || 14}px">${record.text}</span>`,
        items: Object.keys(ridderTypes),
      },
      order: -1,
    },
    {
      id: "OrderNumber",
      columnId: "OrderNumber",
      field: "OrderNumber",
      text: t("OrderNumber"),
      order: -1,
      hidden: false,
    },
    {
      id: "prefix",
      columnId: "prefix",
      field: "prefix",
      text: t("Code"),
      order: -1,
      hidden: false,
    }, 
    {
      id: "CustomerName",
      columnId: "CustomerName",
      field: "CustomerName",
      text: t("CustomerName"),
      order: -1,
      hidden: false,
    },    
    {
      field: "PlanLevel",
      text: "PlanLevel",
      order: -1,
    },
    {
      type: "milestone",
      text: "milestone",
      filterable: getYesNoColumnFilter("milestone"),
      order: -1,
    },
    {
      type: "showintimeline",
      order: -1,
      width: 150,
      filterable: getYesNoColumnFilter("showInTimeline"),
    },
    {
      type: "predecessor",
      order: -1,
      editor: { filterOperator: "*" },
      dependencyIdField: "sequenceNumber",
    },
    {
      editor: false,
      field: "ERPWbs",
      width: 70,
      text: "WBS",
      order: -1,
    },
    {
      field: "index",
      text: "index",
      order: -1,
      hidden: true,
    },
    {
      field: "percentDone",
      type: "percentdone",
      width: 90,
      text: "% Done",
      hidden: true,
      order: -1,
    },
    {
      field: "earlyStartDate",
      type: "earlystartdate",
      width: 130,
      text: "Early Start",
      hidden: true,
      order: -1,
      editor: {
        editable: false,
        autoExpand: true,
        autoClose: true,
      },
    },
    {
      field: "calendar",
      type: "calendar",
      width: 100,
      text: "Calendar",
      hidden: true,
      order: -1,
    },
    {
      field: "constraintDate",
      type: "constraintdate",
      width: 146,
      text: "Constraint Date",
      hidden: true,
      order: -1,
      editor: {
        editable: false,
        autoExpand: true,
        autoClose: true,
      },
    },
    {
      field: "constraintType",
      type: "constrainttype",
      width: 146,
      text: "Constraint Type",
      hidden: true,
      order: -1,
    },
    {
      field: "lateStartDate",
      type: "latestartdate",
      width: 130,
      text: "Late Start",
      hidden: true,
      order: -1,
    },
    {
      type: "schedulingmodecolumn",
      width: 100,
      text: "Scheduling Mode",
      hidden: true,
      order: -1,
    },
    {
      field: "deadlineDate",
      type: "deadlinedate",
      width: 146,
      text: "Deadline",
      hidden: true,
      order: -1,
      editor: {
        editable: false,
        autoExpand: true,
        autoClose: true,
      },
    },
    {
      field: "earlyEndDate",
      type: "earlyenddate",
      width: 130,
      text: "Early End",
      hidden: true,
      order: -1,
      editor: {
        editable: false,
        autoExpand: true,
        autoClose: true,
      },
    },
    {
      field: "lateEndDate",
      type: "lateenddate",
      width: 130,
      text: "Late End",
      hidden: true,
      order: -1,
      editor: {
        editable: false,
        autoExpand: true,
        autoClose: true,
      },
    },
    {
      order: -1,
      width: 160,
      field: 'note',
      text: translate("Note"),
      columnId: 'note',
      editor: {
        type: 'textareapickerfield',
        autoSelect: false,
        listeners: {
          focusIn({ source }) {
            source.showPicker();
            setTimeout(() => {
              setCursorAtEnd(source.input);
            });
          },
          trigger: ({ source }) => {
            setTimeout(() => {
              setCursorAtEnd(source.input);
            });
          },
        },
      },
    },
    {
      field: "rollup",
      type: "rollup",
      width: 100,
      text: "Rollup",
      hidden: true,
      order: -1,
    },
    {
      field: "sequenceNumber",
      type: "sequence",
      id: "sequenceNumber",
      width: 70,
      text: "Sequence",
      hidden: true,
      order: -1,
      region: "left",
    },
    {
      type: "successor",
      width: 120,
      editor: { filterOperator: "*" },
      text: "Successors",
      hidden: true,
      order: -1,
      dependencyIdField: "sequenceNumber",
    },
    {
      field: "totalSlack",
      type: "totalslack",
      width: 100,
      text: translate("Total Slack"),
      hidden: true,
      order: -1,
    },
    {
      editor: false,
      field: "DepartmentDescription",
      text: t("Department"),
      order: -1,
    },
    {
      editor: false,
      field: "WorkActivityDescription",
      text: t("Work Activity"),
      order: -1,
    },
    {
      editor: false,
      field: "WorkActivityGroupDescription",
      text: t("Work Activity Group"),
      order: -1,
    },
    {
      width: 180,
      field: "taskBarColor",
      text: t("taskBarColor"),
      order: -1,
      editor: {
        type: "combo",
        width: 180,
        items: [].concat(ganttColors),
        clearable: true,
        listItemTpl: (record) => `
            <div>
                <span style="vertical-align:middle;display:inline-block;width:16px;height:16px;background: ${record.text};margin-right:8px;"></span>
                <span>${record.text}</span>
            </div>
        `,
        onChange: async ({ source: widget, userAction, value }) => {
          if (userAction) {
            updateTaskbarColorClasses(widget.eventRecord, value);
          }
        },
      },
    },
    {
      width: 250,
      field: "LastSyncMessage",
      text: t("LastSyncMessage"),
      order: -1,
      editor: false,
    },
    {
      width: 100,
      field: "LastSyncMessageType",
      text: t("LastSyncMessageType"),
      order: -1,
      editor: false,
    },
  ];
  return mergeColumns(configs.columns, defaultColumns);
};

const dependencyTabCustomization = {
  items: {
    grid: {
      columns: {
        data: {
          name: {
            renderer({ value }) {
              if (!value) return "";
              return `${value?.name} (${value?.sequenceNumber})`;
            },
            editor: {
              displayValueRenderer(taskRecord) {
                return taskRecord ? `${taskRecord.name} (${taskRecord.sequenceNumber})` : "";
              },
              listItemTpl(taskRecord) {
                return `${taskRecord.name} (${taskRecord.sequenceNumber})`;
              },
            },
          },
        },
      },
    },
  },
};

/**
 * @returns Partial<GanttConfig>
 */
export const getGanttConfig = (configs, generalProjectSettings, parent) => {
  const t = parent.props.t;
  const headerTpl = ({ currentPage, totalPages }) => `
    <div class="demo-export-header">
        <h2>${parent.pageTitle}</h2>  
        <dl>
            <dt>${translate("Date")}: ${dateTimeFormatter(Date.now())}</dt>
            <dd>${totalPages ? `${translate("Page")}: ${currentPage + 1}/${totalPages}` : ""}</dd>
        </dl>
    </div>`;

  const viewPreset = configs.viewPreset || defaultViewPreset;
  const [startDate, endDate] = getMinMaxDate(viewPreset);
  const hideWeekends = configs.hideWeekends || false;
  return {
    height: "100%",
    minHeight: "20em",
    displaySchedulingIssueResolutionPopup: true,
    schedulingIssueResolutionPopupClass: OurSchedulingIssueResolutionPopup,
    cycleResolutionPopupClass: OurCycleResolutionPopup,
    dependencyIdField: "id",
    workingTime: getWorkingTime(hideWeekends),
    enableDeleteKey: false,
    infiniteScroll: true,
    bufferCoef      : 1.5,
    bufferThreshold : 0.1,
    startDate,
    endDate,
    weekStartDay: (generalProjectSettings.StartDayOfWeek == undefined || generalProjectSettings.StartDayOfWeek == null) ? 1 : generalProjectSettings.StartDayOfWeek,   
    labelsFeature: {
      after: {
        renderer({ taskRecord }) {
          return `${taskRecord.description}`;
        },
      },
    },
    cellEditFeature: {
      addNewAtEnd: false,
      triggerEvent: 'cellclick'
    },
    printFeature: {
      headerTpl,
      cls: "exportDialog",
      bodyCls: "exportDialogBody",
      lockPaperSize: true,
      scheduleRange:'daterange',
      exportDialog: {
        autoSelectVisibleColumns: false,
        items: {
          columnsField: { value: ["name", "sequenceNumber"] },
          exporterTypeField: {
            value: "multipagevertical"
          },
        },
      },
    },
    mspExportFeature: true,
    eventSegmentsFeature: {
      disabled: true,
    },
    indicatorsFeature: {
      items: {
        earlyDates: configs.indicatorEarlyDates || false,
        constraintDate: configs.indicatorConstraintDate || false,
        lateDates: configs.indicatorLateDates || false,
        deadlineDate: configs.indicatorDeadlineDate || false,
        materialDate: function (taskRecord) {
          return taskRecord.materialDate
            ? {
              startDate: new Date(taskRecord.materialDate),
              iconCls: "b-fa b-fa-dolly material-indicator",
              name: "Material date",
            }
            : null;
        },
      },
    },
    taskMenuFeature: {
      items: {
        outdent: false,
        indent: false,
        deleteTask: false,
        scrollToTask: getScrollToTaskContextMenu(),
        splitTask: getSplitTaskContextMenu(false),
        splitTaskByHours: getSplitTaskByHourContextMenu(false),
        undoSplit: getUnDoSplitTaskContextMenu(),
        rollup: getRollupContextMenu(),
        convertToMilestone: false, //getConvertToMilestone(),
        add: false,
      },
      processItems({ items, taskRecord }) {
        const allowSplit = !taskRecord.allChildren.length && taskRecord.PastOfLineID == null;
        const taskHasChildren = taskRecord.children?.length > 0;
        Object.keys(items).forEach((item) => {
          if ((item === "splitTask" || item === "splitTaskByHours") && !allowSplit) {
            items[item] = false;
          }
          if (item === "undoSplit" && !taskRecord.OriginalLineID) {
            items[item] = false;
          }
          if (item === "deleteTask" && taskRecord.OriginalLineID) {
            items[item] = false;
          }
          if (item === "rollup" && !taskHasChildren) {
            items[item] = false;
          }
        });
      },
    },
    headerMenuFeature: getHeaderContextMenu(),
    taskTooltipFeature: {
      template: function () {
        return taskBarTooltip.apply(this, [...arguments, parent.generalProjectSettings]);
      },
    },
    timeAxisHeaderMenuFeature: {
      items: {
        eventsFilter: false,
        dateRange: false,
        currentTimeLine: false
      }
    },
    percentBarFeature: {
      allowResize: false,
    },
    quickFindFeature: true,
    rollupsFeature: {
      rollupToAllParents: true,
    },
    filterFeature: true,
    projectLinesFeature: {
      disabled: true,
    },
    baselinesFeature: {
      disabled: !parent.baselineProject, // always on when baseline project
    },
    taskCopyPasteFeature: false,
    rowReorderFeature: false,
    timeRangesFeature: true,
    timeRanges: [
      {
        id: 1,
        name: "Today",
        startDate: DateHelper.add(DateHelper.startOf(new Date(), "day"), 1, 'ms'),
      },
    ],
    taskEditFeature: {
      items: {
        predecessorsTab: dependencyTabCustomization,
        successorsTab: dependencyTabCustomization,
        advancedTab: {
          items: {
            divider: false,
            projectConstraintResolutionField: false,
            constraintDateField: {
              type: "datefield",
              format: "DD-MM-YYYY",
              flex: "1 0 50%",
            },
            effortDrivenField: false,
            rollupField: {
              weight: 350,
            },
            inactiveField: {
              weight:650,
            },                     
            taskbarColorField: {
              type: 'combo',
              name: "taskBarColor",
              label: translate("taskBarColor"),
              weight: 1200,
              clearable:true,
              items: [].concat(ganttColors),
              listItemTpl: (record) => `
                <div>
                    <span style="vertical-align:middle;display:inline-block;width:16px;height:16px;background: ${record.text};margin-right:8px;"></span>
                    <span>${record.text}</span>
                </div>
              `,
            },
          },
        },
        generalTab: {
          items: {
            divider: false,
            name: {
              readOnly: true,
            },
            percentDone: {
              readOnly: true,
            },
            effort: {
              readOnly: true,
            },
            startDate: {
              format: "DD-MM-YYYY",
              flex: "1 0 50%",
            },
            endDate: {
              format: "DD-MM-YYYY",
              flex: "1 0 50%",
            },
          },
        },
      },
      editorConfig: {
        bbar: {
          items: {
            deleteButton: false,
          },
        },
        maximizable: true,     
      },
    },
    listeners: {
      cellDblClick({ record, source: gantt, cellElement }) {
        if (cellElement.dataset.columnId === "name") {
          gantt.editTask(record, cellElement);
        }
      }
    },
    columns: getColumns(configs, t),
    subGridConfigs: {
      locked: {
        flex: 1,
        width: configs.taskGridWidth ? configs.taskGridWidth + "%" : "60%",
      },
      normal: {
        flex: 2,
      },
    },
    presets: getViewPresets(),
    viewPreset,
    showDirty: false,
    rowHeight: 30,
    barMargin: 3,
  };
};

export const generateDataset = async (data, allowExplicit, resourcesAndCalendarsData) => {
  // Required to allow browser to update DOM before calculation starts
  await AsyncHelper.sleep(10);
  const tasksList = flatTasks(data.tasks);
  setMinDurationToPreventBeMilestone(tasksList);
  addDeadlineDateToTasks(tasksList);
  addClasses(tasksList, false);
  addNoResizeAndDrag(tasksList, true, allowExplicit);
  const resourcesData = prepareResources(resourcesAndCalendarsData.resources);
  const calendars = resourcesAndCalendarsData.calendars;
  /**
   * @type Partial<ProjectModelConfig>
   */
  const props = {
    delayCalculation: false,
    project: {
      ...data.project,
      effectiveDirection: {
        kind: "enforced",
      },
      stm: {
        autoRecord: true,
        canRedo: true,
        disabled: false,
        canUndo: true,
      },
    },
    timeRanges: [
      {
        id: 1,
        name: "Today",
        startDate: DateHelper.add(DateHelper.startOf(new Date(), "day"), 1, 'ms'),
      },
    ],
    hoursPerDay: (24-(1/60)),
    daysPerWeek: 5,
    daysPerMonth: 20,
    calendar: "DefaultCompanyCalendar",
    startDate: data.projectStartdate,
    endDate: data.projectEnddate,
    enableProgressNotifications: true,
    calendarManagerStore: { useRawData: true },
    calendarsData: calendars,
    taskStore: {
      useRawData: false,
      modelClass: GanttTask,
      reapplyFilterOnAdd: true,
      reapplyFilterOnUpdate: false,
      sorters: [
        { field: "ERPWbs", ascending: true },
        { field: "segmentSeqNr", ascending: true }
      ],
      listeners: {
        update: ({ source, record, changes }) => {          
          if (changes.hasOwnProperty("taskBarColor")) {
            updateTaskbarColorClasses(record, changes.taskBarColor.value);
          }
        },
      },    
    },
    resourceStore: {
      useRawData: true
    },
    assignmentStore: new AssignmentStore({
      useRawData: true,
      data: data.bryntumAssignments,
      onBeforeAdd: preventAddAssignmentsForOutsourced,
    }),
    dependencyStore: {
      useRawData: true,
      modelClass: GanttDependency,
    },
    tasksData: data.tasks,
    dependenciesData: data.bryntumDependencies,
    resourcesData,
    silenceInitialCommit: false,
  };

  return {
    projectData: props,
    resourcesData,
    calendarsData: JSON.parse(JSON.stringify(calendars)),
    dependenciesData: data.bryntumDependencies,
    tasksData: data.tasks,
    assignmentsData : data.bryntumAssignments,
  };
};
